import { UnderLineButton } from "@components/atoms/underline-link/index.client";
import { CartEmpty } from "@components/molecules/cart/cart-empty.client";
import { CheckoutActions } from "@components/molecules/cart/checkout-actions.client";
import { LineItem } from "@components/molecules/cart/lines-item/index";
import { OrderSummary } from "@components/molecules/cart/order-summary.client";
import { translate } from "@locales";
import { userAtom } from "@models/state/customer";
import { CartLineProvider, useCart } from "@shopify/hydrogen";
import { useAtomValue } from "jotai";

interface CartDetailsProps {
  onClose: () => void;
}

function useCartDetails(onClose: CartDetailsProps["onClose"]) {
  const customer = useAtomValue(userAtom);
  return {
    models: {
      customer,
    },
    operations: {
      onClose,
    },
  };
}

export function CartDetails({ onClose }: CartDetailsProps) {
  const { models, operations } = useCartDetails(onClose);
  const { lines } = useCart();

  if (!lines.length) {
    return <CartEmpty onClose={onClose} />;
  }

  return (
    <form className="grid grid-rows-[1fr_390px] lg:grid-rows-[1fr_420px] h-screen">
      <section
        aria-labelledby="cart-contents"
        className="overflow-auto transition px-5 lg:px-[38px]"
      >
        <p className="font-chivo-regular text-xs py-6">
          {!models.customer && (
            <>
              <UnderLineButton content={translate("base.register")} onClose={operations.onClose} to="/sign-up" />
              {translate("shop.cart.save-items-for-later.0")}{" "}
              <UnderLineButton content={translate("base.signin")} onClose={operations.onClose} to="/sign-in" />
              {translate("shop.cart.save-items-for-later.1")}
            </>
          )}
        </p>

        <ul className="grid gap-6 lg:gap-10 mb-10">
          {lines.map((line) => {
            return (
              <CartLineProvider key={line.id} line={line}>
                <LineItem isDrawer  onclose={onClose}/>
              </CartLineProvider>
            );
          })}
        </ul>
      </section>
      <section className="w-full">
        <section
          aria-labelledby="summary-heading"
          className="border-t py-4 px-5 lg:px-[38px]"
        >
          <h2 id="summary-heading" className="sr-only">
            {translate("shop.order-summary")}
          </h2>
          <OrderSummary />
        </section>
        <section className="border-t px-5 lg:px-[38px]">
          <CheckoutActions />
        </section>
      </section>
    </form>
  );
}
